
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M1 7h22v4H1z"}}),_c('rect',{attrs:{"width":"22","height":"17.11","x":"1","y":"3.44","stroke":"#000","rx":"1.83"}}),_c('rect',{attrs:{"width":"4","height":"1.38","x":"3.5","y":"15.61","fill":"#FFD250","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"8","height":"1.38","x":"8.5","y":"15.61","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}})])])
          )
        }
      }
    